import { render, staticRenderFns } from "./login-com.vue?vue&type=template&id=dba2aa34&scoped=true"
import script from "./login-com.vue?vue&type=script&lang=js"
export * from "./login-com.vue?vue&type=script&lang=js"
import style0 from "./login-com.vue?vue&type=style&index=0&id=dba2aa34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba2aa34",
  null
  
)

export default component.exports